import { axiosInstance } from './axios-instance';
import { PAGE_SIZE } from '../magic-values';
import type { PaginatedResult, PaginationDto } from '../types/common';
import type { AdminUserDoc } from '../types/user';

export interface UsersFilters {
  accountId?: string;
  filterBy?: string;
}

export class UserService {
  static async getUsers(
    filters?: UsersFilters,
    pagination?: PaginationDto,
  ): Promise<PaginatedResult<AdminUserDoc>> {
    const res = await axiosInstance.get<PaginatedResult<AdminUserDoc>>('/admin/users', {
      params: { pageSize: PAGE_SIZE, ...pagination, ...filters },
    });
    return res.data;
  }

  static async getUser(id: string): Promise<AdminUserDoc> {
    const res = await axiosInstance.get<AdminUserDoc>(`/admin/users/${id}`);
    return res.data;
  }
}
